// src/Dashboard/components/DashboardMainContent.jsx

import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useDashboardLayout } from "../contexts/DashboardLayoutContext";

import DashboardHome from "../pages/DashboardHome";
import DashboardNotFound from "../pages/DashboardNotFound";
import DashboardFooter from "./DashboardFooter";

// Import des pages admin
import DashboardAdherents from "../pages/admin/DashboardAdherents/DashboardAdherents";
import DashboardCompta from "../pages/admin/DashboardCompta/DashboardCompta";
import UserListing from "../pages/admin/UserListing/UserListing";
import ListingAdherentsAdmin from "../pages/admin/Adherents/ListingAdherentsAdmin";
import ReglementInscription from "../pages/admin/ReglementInscription/ReglementInscriptionPage";
import DossierInscriptionPage from "../pages/admin/DossierInscription/DossierInscriptionPage";
import DetailsAdherentDashboard from "../pages/admin/DetailsAdherent/DetailsAdherentDashboard";
import ArticlesDashboard from "../pages/admin/Articles/ArticlesDashboard";
import CoachingDashboard from "../pages/admin/Coaching/CoachingDashboard";
import HeuresEnseignementDashboard from "../pages/admin/HeuresEnseignement/HeuresEnseignementDashboard";
import InventaireDashboard from "../pages/admin/Inventaire/InventaireDashboard";
import AdherentPretDashboard from "../pages/admin/AdherentPret/AdherentPretDashboard";
import PaymentsDashboard from "../pages/admin/Payments/PaymentsDashboard";
import MessagesDashboard from "../pages/admin/Messages/MessagesDashboard";
import VotesDashboard from "../pages/admin/Votes/VotesDashboard";
import PagesDashboard from "../pages/admin/PagesPersonnalisees/PagesDashboard";
import RequestsDashboard from "../pages/admin/Requests/RequestsDashboard";
import AbonnementDashboard from "../pages/admin/Abonnement/AbonnementDashboard";
import UpdatesDashboard from "../pages/admin/Updates/UpdatesDashboard";
import SettingsDashboard from "../pages/admin/Settings/SettingsDashboard";
import DepensesRecettesDashboard from "../pages/admin/DepensesRecettesDashboard/DepensesRecettesDashboard";
import ExpensePageAdmin from "../pages/admin/ExpenseClaims/ExpensePageAdmin";
import SeasonStatsDashboard from "../pages/admin/SeasonStats/SeasonStatsDashboard"

// Import des pages enseignant
import PalmaresDashboard from "../pages/teacher/Palmares/PalmaresDashboard";
import TechniquesDashboard from "../pages/teacher/Techniques/TechniquesDashboard";
import ToDoListDashboard from "../pages/teacher/ToDoList/ToDoListDashboard";
import ObjectifsDashboard from "../pages/teacher/Objectifs/ObjectifsDashboard";
import CategoriesDashboard from "../pages/teacher/Categories/CategoriesDashboard";
import EventsDashboard from "../pages/teacher/Events/EventsDashboard";
import GradeCNDashboard from "../pages/teacher/GradeCN/GradeCNDashboard";
import PassageCeintureDashboard from "../pages/teacher/Belts/PassageCeintureDashboard";
import ListingAdherentsPage from "../pages/teacher/ListingAdherents/ListingAdherentsPage";
import SuiviCompetitionsDashboard from "../pages/teacher/SuiviCompetitions/SuiviCompetitionsDashboard";
import PrepaPhysiqueDashboard from "../pages/teacher/PrepaPhysique/PrepaPhysiqueDashboard";
import AttendanceDashboard from "../pages/teacher/Attendance/AttendanceDashboard";
import AttendanceTableDashboard from "../pages/teacher/AttendanceTable/AttendanceTableDashboard";
import TeacherHelpPage from "../pages/teacher/Help/TeacherHelpPage";

// Import des pages user
import TechniquesUserDashboard from "../pages/user/Techniques/TechniquesUserDashboard";
import TechniquesQuizzDashboard from "../pages/user/TechniquesQuizz/TechniquesQuizzDashboard";
import UserVoteDashboard from "../pages/user/Vote/UserVoteDashboard";
import PrepaPhysiqueUserDashboard from "../pages/user/PrepaPhysique/PrepaPhysiqueUserDashboard";
import PassageCeintureDocumentsDashboard from "../pages/user/PassageCeintureDocuments/PassageCeintureDocumentsDashboard";
import ProduitsDashboard from "../pages/user/Produits/ProduitsDashboard";
import ArbitrageJudoDashboard from "../pages/user/ArbitrageJudo/ArbitrageJudoDashboard";
import LexiqueDashboard from "../pages/user/Lexique/LexiqueDashboard";
import GalleriesPhotosDashboard from "../pages/user/Galleries/GalleriesPhotosDashboard";
import AlbumGalerieDashboard from "../pages/user/Galleries/AlbumGalerieDashboard";
import NewsDashboard from "../pages/user/News/NewsDashboard";
import ReglementsDashboard from "../pages/user/Reglements/UsersReglementsDashboard";
import BoutiqueDashboard from "../pages/user/Boutique/BoutiqueDashboard";
import MessagingDashboard from "../pages/user/Messaging/MessagingDashboard";
import CalendarEventsDashboard from "../pages/user/CalendarEvents/CalendarEventsDashboard";
import AbsencesDashboard from "../pages/user/Absences/AbsencesDashboard";
import InscriptionDashboard from "../pages/user/Inscription/InscriptionDashboard";
import DashboardUser from "../pages/user/DashboardUsers/DashboardUser";
import FicheAdherentDashboard from "../pages/user/FicheAdherent/FicheAdherentDashboard";

export default function DashboardMainContent() {
  const { isCollapsed } = useDashboardLayout();

  return (
    <main
      className={`min-h-screen pt-[82px] transition-[margin,width] duration-300 ${
        isCollapsed
          ? "lg:ml-24 lg:w-[calc(100%-6rem)]"
          : "lg:ml-72 lg:w-[calc(100%-18rem)]"
      }`}
    >
      <div className="relative flex min-h-[calc(100dvh-82px)] flex-col overflow-x-hidden bg-slate-100 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
        <div className="pointer-events-none absolute inset-0 opacity-70 dark:opacity-40">
          <div className="absolute -top-24 right-[-120px] h-72 w-72 rounded-full bg-indigo-300/30 blur-3xl dark:bg-indigo-500/10" />
          <div className="absolute left-[-120px] top-[20%] h-72 w-72 rounded-full bg-emerald-300/20 blur-3xl dark:bg-emerald-500/10" />
        </div>

        <div className="relative mx-auto flex min-h-[calc(100dvh-82px)] w-full max-w-[1900px] flex-1 flex-col">
          <div className="flex-1">
            <Routes>
              <Route
                index
                element={<Navigate to="tableau-de-bord" replace />}
              />

              {/* ADMIN */}
              <Route
                path="dashboard-adherents"
                element={<DashboardAdherents />}
              />
              <Route
                path="dashboard-comptabilite"
                element={<DashboardCompta />}
              />

              <Route path="listing-utilisateurs" element={<UserListing />} />
              <Route
                path="listing-adherents-admin"
                element={<ListingAdherentsAdmin />}
              />
              <Route
                path="reglements-inscriptions"
                element={<ReglementInscription />}
              />
              <Route
                path="dossiers-d-inscription"
                element={<DossierInscriptionPage />}
              />
              <Route
                path="details-adherent"
                element={<DetailsAdherentDashboard />}
              />
              <Route path="articles-admin" element={<ArticlesDashboard />} />
              <Route path="coachings" element={<CoachingDashboard />} />
              <Route
                path="heures-enseignement"
                element={<HeuresEnseignementDashboard />}
              />
              <Route path="fiche-de-frais-admin" element={<ExpensePageAdmin />} />
              <Route path="inventaire" element={<InventaireDashboard />} />
              <Route path="pret-materiel" element={<AdherentPretDashboard />} />
              <Route path="paiements" element={<PaymentsDashboard />} />
              <Route path="message-admin" element={<MessagesDashboard />} />
              <Route path="vote-sondage-admin" element={<VotesDashboard />} />
              <Route path="pages-personnalisees" element={<PagesDashboard />} />
              <Route path="requetes-admin" element={<RequestsDashboard />} />
              <Route path="abonnement" element={<AbonnementDashboard />} />
              <Route path="update" element={<UpdatesDashboard />} />
              <Route path="parametres" element={<SettingsDashboard />} />
              <Route path="depenses-recettes" element={<DepensesRecettesDashboard />} />
              <Route path="statistiques-saisons" element={<SeasonStatsDashboard />} />

              {/* ENSEIGNANT */}
              <Route path="palmares" element={<PalmaresDashboard />} />
              <Route
                path="techniques-enseignants"
                element={<TechniquesDashboard />}
              />
              <Route path="todolist" element={<ToDoListDashboard />} />
              <Route path="objectifs" element={<ObjectifsDashboard />} />
              <Route path="categories" element={<CategoriesDashboard />} />
              <Route path="evenements" element={<EventsDashboard />} />
              <Route path="grade-cn" element={<GradeCNDashboard />} />
              <Route
                path="passage-ceinture"
                element={<PassageCeintureDashboard />}
              />
              <Route
                path="listing-adherents"
                element={<ListingAdherentsPage />}
              />
              <Route
                path="suivi-competitions"
                element={<SuiviCompetitionsDashboard />}
              />
              <Route
                path="prepa-physique-coaching"
                element={<PrepaPhysiqueDashboard />}
              />
              <Route path="appel-presence" element={<AttendanceDashboard />} />
              <Route
                path="tableau-appel"
                element={<AttendanceTableDashboard />}
              />
              <Route path="aide-enseignants" element={<TeacherHelpPage />} />

              {/* USER */}
              <Route
                path="techniques-judo"
                element={<TechniquesUserDashboard />}
              />
              <Route
                path="techniques-quizz"
                element={<TechniquesQuizzDashboard />}
              />
              <Route
                path="vote-sondage-utilisateur"
                element={<UserVoteDashboard />}
              />
              <Route
                path="prepa-physique"
                element={<PrepaPhysiqueUserDashboard />}
              />
              <Route
                path="documents-passage-ceinture"
                element={<PassageCeintureDocumentsDashboard />}
              />
              <Route path="applications-judo" element={<ProduitsDashboard />} />
              <Route
                path="arbitrage-judo"
                element={<ArbitrageJudoDashboard />}
              />
              <Route path="lexique" element={<LexiqueDashboard />} />
              <Route
                path="galerie-photos"
                element={<GalleriesPhotosDashboard />}
              />
              <Route
                path="galerie-photos/album/:albumId"
                element={<AlbumGalerieDashboard />}
              />
              <Route path="actualites" element={<NewsDashboard />} />
              <Route
                path="commandes-&-reglements"
                element={<ReglementsDashboard />}
              />
              <Route path="boutique" element={<BoutiqueDashboard />} />
              <Route path="messages" element={<MessagingDashboard />} />
              <Route path="calendrier" element={<CalendarEventsDashboard />} />
              <Route path="absences" element={<AbsencesDashboard />} />
              <Route
                path="dossier-d-inscription"
                element={<InscriptionDashboard />}
              />
              <Route path="tableau-de-bord" element={<DashboardUser />} />
              <Route path="fiche-adherent" element={<FicheAdherentDashboard />} />

              <Route path="*" element={<DashboardNotFound />} />
            </Routes>
          </div>

          <DashboardFooter />
        </div>
      </div>
    </main>
  );
}
